<template>
  <div class="animated fadeIn">
    <b-card>
      <div class="display-table full-width mb-2">
        <strong class="card-title">Dashboard Rumah Tangga</strong>
      </div>
      <b-row>
        <b-col md="4">
          <select class="form-control mb-3" v-model="models.year" @change="getData">
            <option value="2024">2024</option>
            <option value="2025">2025</option>
          </select>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <B3TerlayaniBar :models="models"/>
        </b-col>
        <b-col md="4">
          <B3Dikelola :models="models"/>
        </b-col>
         <b-col md="4">
          <p class="subtitle">Peta Sebaran Sampah B3/LB3 Di Wilayah DKI Jakarta tahun {{ models.year }}</p>
          <div id="map" :style="{ height: '300px' }"></div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <b-form-group class="my-3" label="">
						<select v-model="models.idKota" required class="form-control" @change="getData">
							<option value="">Pilih Kota</option>
							<option v-for="(v,i) in masters.cities" :value="v.id" :key="i">
								{{v.namaKota}}
							</option>
						</select>
					</b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4">
          <p class="subtitle">Jumlah Sampah B3/ LB3 Rumah Tangga per Kelurahan, Tahun {{ models.year }}</p>
          <div class="table-responsive">
						<table class="table b-table">
              <thead>
                <tr>
                  <th class="bg-green">Kelurahan</th>
                  <th class="bg-green">Jumlah Sampah B3/LB3 (Kg)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v,k) in kelurahanData" :key="k">
                  <td>{{v.namaKelurahan}}</td>
                  <td align="right">{{v.jumlahSampahB3}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
        <b-col md="4">
          <p class="subtitle">Jumlah Sampah B3/ LB3 Rumah Tangga per Kecamatan, Tahun {{ models.year }}</p>
          <div class="table-responsive">
						<table class="table b-table">
              <thead>
                <tr>
                  <th class="bg-green">Kecamatan</th>
                  <th class="bg-green">Jumlah Sampah B3/LB3 (Kg)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v,k) in kecamatanData" :key="k">
                  <td>{{v.namaKecamatan}}</td>
                  <td align="right">{{v.jumlahSampahB3}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
        <b-col md="4">
          <p class="subtitle">Jumlah Sampah B3/ LB3 Rumah Tangga per Kota / Kabupaten, Tahun {{ models.year }}</p>
          <div class="table-responsive">
						<table class="table b-table">
              <thead>
                <tr>
                  <th class="bg-green">Kota/Kabupaten</th>
                  <th class="bg-green">Jumlah Sampah B3/LB3 (Kg)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v,k) in kotaData" :key="k">
                  <td>{{v.namaKota}}</td>
                  <td align="right">{{v.jumlahSampahB3}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>
<style>
.chart{
  width: 100%;
  overflow: scroll;
}
.subtitle{
    font-weight: 900;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 14px;

}
.bg-green{
  background: #169e35;
  color: #fff;
}
</style>

<script>
  import B3TerlayaniBar from './b3_terlayani_bar';
  import B3Dikelola from './b3_dikelola';
  import L from 'leaflet';
  import 'leaflet/dist/leaflet.css';
  import markerIcon from "leaflet/dist/images/marker-icon.png";
  import markerShadow from "leaflet/dist/images/marker-shadow.png";
  import moment from 'moment';
  export default {
    name: 'dashboard',
    components: {
      B3TerlayaniBar,
      B3Dikelola,
    },
    data: function () {
      return {
        map: null,
        models: {
          year: moment().format('YYYY'),
          idKota: ""
        },
        mapsMarkers: [],
        kelurahanData: [],
        kecamatanData: [],
        kotaData: [],
        masters: {
					cities: []
				}
      }
    },
    mounted(){
      this.getData();
    },
    methods: {
      getData(){
        this.getMaps();
        this.getJumlahSampahRumahTanggaPerKelurahan();
        this.getJumlahSampahRumahTanggaPerKecamatan();
        this.getJumlahSampahRumahTanggaPerKota();
      },
      getCities() {
				const _ = this
				_.$axios.get('Kota')
				.then(res => {
					_.masters.cities = res.data.data;
				});
			},
      getMaps() {
        const _ = this;
        _.$axios.get('DashboardRumahTangga/MapsRumahTangga', {
          params: {
            startDate: `${_.models.year}-01-01`,
            endDate: `${_.models.year}-12-31`,
          }
        })
        .then(res => {
          _.mapsMarkers = res.data.data;
          _.initMap();
        })
      },
      getJumlahSampahRumahTanggaPerKelurahan() {
        const _ = this;
        _.$axios.get('DashboardRumahTangga/JumlahSampahRumahTanggaPerKelurahan', {
          params: {
            years: _.models.year,
            idKota: _.models.idKota,
          }
        })
        .then(res => {
          _.kelurahanData = res.data.data;
        })
      },
      getJumlahSampahRumahTanggaPerKecamatan() {
        const _ = this;
        _.$axios.get('DashboardRumahTangga/JumlahSampahRumahTanggaPerKecamatan', {
          params: {
            years: _.models.year,
            idKota: _.models.idKota,
          }
        })
        .then(res => {
          _.kecamatanData = res.data.data;
        })
      },
      getJumlahSampahRumahTanggaPerKota() {
        const _ = this;
        _.$axios.get('DashboardRumahTangga/JumlahSampahRumahTanggaPerKota', {
          params: {
            years: _.models.year,
          }
        })
        .then(res => {
          _.kotaData = res.data.data;
        })
      },
      initMap(){
        const _ = this;

        if (_.map) {
          _.map.remove();
        }

        // Initialize the map
        _.map = L.map('map').setView([-6.2088, 106.8456], 10);

        // Add OpenStreetMap tiles
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }).addTo(_.map);

        // Set custom marker icon
        const customIcon = L.icon({
          iconUrl: markerIcon,
          shadowUrl: markerShadow,
          iconSize: [25, 41], // Default Leaflet icon size
          iconAnchor: [12, 41], // Anchor the icon properly
        });

        _.mapsMarkers.forEach((marker) => {
          const newMarker = L.marker([marker.longitude, marker.latitude], { icon: customIcon }).addTo(_.map);
          // Add popup if provided
          if (marker.namaKelurahan) {
            newMarker.bindPopup("Total: " + marker.namaKelurahan).openPopup();
          }
        });
      }
    },
    beforeMount() {
        // Clean up the map instance when the component is destroyed
        if (this.map) {
            this.map.remove();
        }
    },
    created(){
      this.$axios.get('Authentication/me');
      this.getCities();
    }
  }
</script>